/** @format */

import {MediaplanRecord} from './types';

export const STATS_PROVIDERS = ['METRIKA', 'WEBDAV'];

export const MEDIAPLAN_RECORDS: MediaplanRecord = {
  PERFORM: {
    title: 'За клики',
    description: 'Перформ-кампании',
  },
  MEDIA: {
    title: 'За показы',
    description: 'Медийные кампании',
  },
};
